import styled from 'styled-components';

export const MainComponentLayout = styled.div`
  padding-top: ${(props) =>
    props.noPaddingTop || props.showHeader === '-56px'
      ? '0'
      : props.paddingTop
        ? props.paddingTop
        : '65px'};
  @media (min-width: 768px) {
    padding-top: ${(props) =>
      props.paddingTopDesktop
        ? props.paddingTopDesktop
        : props.showHeader === '-56px' || props.noPaddingTop
          ? '0'
          : '170px'};
  }
  .stickySection {
    @media (min-width: 768px) {
      overflow-x: hidden !important;
      height: max-content;
      position: sticky;
      transition: top 0.3s linear;
      top: ${(props) => (props.showHeader === '-56px' ? '88px' : '140px')};
    }
  }
  overflow-x: clip;
`;
